import { core } from '@musinsa/pbo-core'
import { useCoMingleShipperScope } from '@/components/system/useCoMingleShipperScope'
import { useIvlInventoryEnabled } from '@/services/inventory/inventoryStatus/useIvlInventoryQueries'
import InventoryStatus from './index'

/**
 * BE와 같은 스위치를 조회한다. 전환 시 이전 모드의 센터값과 조회 결과를 재사용하지 않는다.
 * 화면은 화주 범위를 첫 렌더에 고정하므로 재고통합 FF 값도 정해진 뒤에 연다(LOGISPRD-15610).
 */
export default function InventoryStatusRoute() {
  const mode = useIvlInventoryEnabled()
  const coMingle = useCoMingleShipperScope()
  if (mode.isError) return (
    <div role="alert">
      재고현황을 준비하지 못했어요. 다시 시도해 주세요.
      <core.Button onClick={() => { mode.refetch().catch(() => undefined) }}>다시 시도</core.Button>
    </div>
  )
  if (mode.isPending || !coMingle.ready) return <div role="status">재고현황을 준비하고 있어요.</div>
  return <InventoryStatus key={mode.data ? 'ivl' : 'legacy'} ivlEnabled={mode.data} coMingle={coMingle.coMingle} />
}
